import { render, staticRenderFns } from "./ConfirmInvoicePay.vue?vue&type=template&id=52a94cf6&scoped=true&"
import script from "./ConfirmInvoicePay.vue?vue&type=script&lang=js&"
export * from "./ConfirmInvoicePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a94cf6",
  null
  
)

export default component.exports